import InvoiceCustomer from '@/classes/case/InvoiceCustomer'
import invoiceCustomerApi from '@/api/customer/invoiceCustomerApi'
import FormData from '@/classes/form/FormData'
import FormDescriptor from '@/classes/form/FormDescriptor'
import { findItem, getFilter } from '@/store/utility_functions'

const DEFAULT_SORT = 'company_name'

const state = {
  invoiceCustomers: [],
  invoiceCustomerFormDescriptors: [],
  invoiceCustomerFormDatas: []
}
const mutations = {
  setStateInvoiceCustomers: (state, data) => {
    state.invoiceCustomers = InvoiceCustomer.asInvoiceCustomers(data)
  },
  addToStateInvoiceCustomer: (state, invoiceCustomer) => {
    state.invoiceCustomers.push(invoiceCustomer)
  },
  updateStateInvoiceCustomers: (state, data) => {
    data.current.updateCurrentInvoiceCustomer(data.updated)
  },
  setStateInvoiceCustomerFormDescriptors: (state, data) => {
    state.invoiceCustomerFormDescriptors = FormDescriptor.asFormDescriptors(data)
  },
  setStateInvoiceCustomerFormDatas: (state, data) => {
    state.invoiceCustomerFormDatas = FormData.initiateFormDatas(state.invoiceCustomerFormDescriptors)
    FormData.loadInitialFormDatas(data, state.invoiceCustomerFormDatas)
    FormDescriptor.checkFormDescriptorsDependencies(state.invoiceCustomerFormDescriptors, state.invoiceCustomerFormDatas)
  }
}
const actions = {
  getInvoiceCustomersForOrgNumber ({ commit }, orgNumber) {
    let filter = `?org_number=${orgNumber}&page_size=100`
    return invoiceCustomerApi.getInvoiceCustomers(filter).then((response) => {
      return InvoiceCustomer.asInvoiceCustomers(response.data.results)
    }).catch((err) => {
      throw err
    })
  },
  getInvoiceCustomers ({ commit }, request) {
    request.ordering = request.ordering || DEFAULT_SORT
    let filter = getFilter(request)
    return invoiceCustomerApi.getInvoiceCustomers(filter).then((response) => {
      commit('setStateInvoiceCustomers', response.data.results)
      return response.data
    }).catch((err) => {
      throw err
    })
  },
  setInvoiceCustomer ({ commit, state }, invoiceCustomerId) {
    return invoiceCustomerApi.getInvoiceCustomer(invoiceCustomerId).then((response) => {
      let invoiceCustomer = InvoiceCustomer.asInvoiceCustomer(response.data)
      let existingItem = findItem(state.invoiceCustomers, invoiceCustomer.id)
      if (existingItem) {
        commit('updateStateInvoiceCustomers', {
          current: existingItem,
          updated: invoiceCustomer
        })
      } else {
        commit('addToStateInvoiceCustomer', invoiceCustomer)
      }
      return invoiceCustomer
    }).catch((err) => {
      throw err
    })
  },
  setHistoricalInvoiceCustomer ({ commit, state }, invoiceId) {
    return invoiceCustomerApi.getHistoricalInvoiceCustomer(invoiceId).then((response) => {
      let invoiceCustomer = InvoiceCustomer.asInvoiceCustomer(response.data)
      let existingItem = findItem(state.invoiceCustomers, invoiceCustomer.id)
      if (existingItem) {
        commit('updateStateInvoiceCustomers', {
          current: existingItem,
          updated: invoiceCustomer
        })
      } else {
        commit('addToStateInvoiceCustomer', invoiceCustomer)
      }
      return invoiceCustomer
    }).catch((err) => {
      throw err
    })
  },
  setupInvoiceCustomerCreateForm ({ commit, state }) {
    return invoiceCustomerApi.getInvoiceCustomerCreateForm().then((response) => {
      commit('setStateInvoiceCustomerFormDescriptors', [response.data])
      commit('setStateInvoiceCustomerFormDatas', [])
    }).catch((err) => {
      throw err
    })
  },
  setupInvoiceCustomerEditForm ({ commit, state }, invoiceCustomerId) {
    return invoiceCustomerApi.getInvoiceCustomerEditForm(invoiceCustomerId).then((response) => {
      commit('setStateInvoiceCustomerFormDescriptors', [response.data])
      commit('setStateInvoiceCustomerFormDatas', [response.data.form_data])
    }).catch((err) => {
      throw err
    })
  },
  postInvoiceCustomerCreateForm ({ commit }, requestData) {
    return invoiceCustomerApi.postInvoiceCustomerCreateForm(requestData.serializedData).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  },
  patchInvoiceCustomerEditForm ({ commit }, requestData) {
    return invoiceCustomerApi.patchInvoiceCustomerEditForm(requestData.data.invoiceCustomerId, requestData.serializedData).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  }
}

export default {
  state,
  mutations,
  actions
}
